module.exports = __webpack_public_path__ + "img/cubo-branco.215b2452.svg";